/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Products_TitleInputs */

const en_inventory_products_title = /** @type {(inputs: Inventory_Products_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventory Products`)
};

const es_inventory_products_title = /** @type {(inputs: Inventory_Products_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Productos de inventario`)
};

/**
* | output |
* | --- |
* | "Inventory Products" |
*
* @param {Inventory_Products_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_products_title = /** @type {((inputs?: Inventory_Products_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Products_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_products_title(inputs)
	return es_inventory_products_title(inputs)
});